<template>
    <div>{{ layer.name }}
        <button :disabled="project.activeLayer === layer" @click="project.activateLayer(layer)">A</button>
        <button :disabled="project.layers.length === 1" @click="project.deleteLayer(layer)">(X)</button>
    </div>
</template>

<script>
    export default {
        name: "Layer",

        props: [
            'project',
            'layer'
        ]
    }
</script>

<style scoped>

</style>
